

















import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component
export default class ImageWithBadgeBand extends Vue {
  @Prop({ required: true })
  imageSrc: string

  @Prop({ default: 'c-badge-band' })
  rootClass: string

  @Prop({ default: '' })
  imageClass: string

  @Prop({ default: false })
  lazy: boolean

  @Prop({ default: null })
  badgeBandSrc: string | null

  @Prop({ default: undefined })
  height: number | undefined

  @Prop({ default: undefined })
  width: number | undefined

  get withBand(): boolean {
    return !!this.badgeBandSrc
  }

  get loading(): 'lazy' | 'eager' {
    return this.lazy ? 'lazy' : 'eager'
  }
}
